import { gql, useQuery } from "@apollo/client";
import useRequestBeforeLogin from "src/utils/hook/base/useRequestBeforeLogin";
const Q_ActiveSubcategoryList = gql`
  query getActiveSubcategoryList($category: ID!, $port: String) {
    activeSubcategoryList(category: $category, port: $port) {
      edges {
        node {
          title
          id
        }
      }
    }
  }
`;

function useGetActiveSubcategoryList(Id, port) {
  const { requestConfig } = useRequestBeforeLogin();
  const { loading, error, data, refetch } = useQuery(Q_ActiveSubcategoryList, {
    ...requestConfig({
      module: "AVC_TICKET",
      variables: {
        category: parseInt(Id),
        port: port,
      },
    }),
    skip: !Id,
  });

  return { loading, error, data, refetch };
}
export default useGetActiveSubcategoryList;
